import { attach, createEvent, createStore, sample } from "effector";

import { closeSession } from "@entities/session";

type QueriesState = {
  invalidate: () => Promise<void>;
};

export const setQueryClient = createEvent<QueriesState>();

export const $queryClient = createStore<QueriesState | null>(null).on(
  setQueryClient,
  (_, queryClient) => queryClient,
);

export const invalidateQueriesFx = attach({
  effect: (queryClient) => {
    if (!queryClient) {
      return;
    }
    return queryClient.invalidate();
  },
  source: $queryClient,
});

sample({
  clock: closeSession,
  target: invalidateQueriesFx,
});
